import PlayerEvolution from "./EvolutionParCategorie";
export default PlayerEvolution;
